import { useMemo } from "react";
import {
    CoaMappingTableCallbacks,
    CoaMappingTableMeta,
    CoaMappingTableOptions,
} from "./coaMappingTableMeta";

type Params = CoaMappingTableOptions & CoaMappingTableCallbacks;

export function useCoaMappingTableMeta({
    entityId,
    isCreateAccountAvailable,
    isAccountsMappingRunning,
    kickAccountsById,
    kickGroups,
    showAccountNumbers,
    onMapAccount,
    onOpenCreateAccountModal,
}: Params): CoaMappingTableMeta {
    return useMemo(
        () => ({
            options: {
                entityId,
                isCreateAccountAvailable,
                isAccountsMappingRunning,
                kickAccountsById,
                kickGroups,
                showAccountNumbers,
            },
            callbacks: {
                onMapAccount,
                onOpenCreateAccountModal,
            },
        }),
        [
            entityId,
            isCreateAccountAvailable,
            isAccountsMappingRunning,
            kickAccountsById,
            kickGroups,
            showAccountNumbers,
            onMapAccount,
            onOpenCreateAccountModal,
        ],
    );
}
